module.exports = __webpack_public_path__ + "img/penta-re-logo.9ed0ec10.svg";